import { styled } from '@mui/material/styles';
import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ErrorOutline } from '@mui/icons-material';
import { ButtonProps } from '@mui/material/Button';

import { AppBar } from '@lialo/pwa-ui/lib/PageComponents/AppBar';
import { Page } from '@lialo/pwa-ui/lib/PageComponents/Page';

import RouterBackButton from '../AppBarButtons/RouterBackButton';
import { To } from '@lialo/core/lib/services';

const PREFIX = 'BaseErrorPage';

const classes = {
  center: `${PREFIX}-center`,
  button: `${PREFIX}-button`,
};

const StyledPage = styled(Page)(({ theme }) => ({
  [`& .${classes.center}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },

  [`& .${classes.button}`]: {
    marginTop: theme.spacing(2),
  },
}));

interface IProps {
  message: string;
  actionButton?: React.ReactElement<ButtonProps>;
  parentUrl: To;
}

const BaseErrorPage = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <StyledPage>
      <AppBar title={t('errors.error')} leftElement={<RouterBackButton parentUrl={props.parentUrl} />} />
      <div className={classes.center}>
        <ErrorOutline fontSize={'large'} />
        <Typography>{props.message}</Typography>
        {props.actionButton &&
          React.cloneElement(props.actionButton, {
            className: classes.button,
            color: 'primary',
          })}
      </div>
    </StyledPage>
  );
};

export default BaseErrorPage;
